// start:ng42.barrel
export * from './breadcrumb.component';
// end:ng42.barrel
